import { Routes } from '@angular/router';
import { GuestComponent } from './theme/guest/guest.component';
import { NoAuthGuard } from './guard/no-auth.guard';
import { AuthGuard } from './guard/auth.guard';
import { AdminComponent } from './theme/admin/admin.component';

export const routes: Routes = [
  {
    path: '',
    component: AdminComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'appointments',
        pathMatch: 'full',
      },
      {
        path: 'profile',
        loadComponent: () =>
          import(
            './pages/user-profile/user-profile/user-profile.component'
          ).then((m) => m.UserProfileComponent),
      },
      {
        path: 'users',
        loadComponent: () =>
          import('./pages/users/users.component').then((m) => m.UsersComponent),
      },
      {
        path: 'companies',
        loadComponent: () =>
          import('./pages/company/company.component').then(
            (m) => m.CompanyComponent
          ),
      },
      {
        path: 'patients',
        loadComponent: () =>
          import('./pages/patients/patient.component').then(
            (m) => m.PatientComponent
          ),
      },
      {
        path: 'appointments',
        loadComponent: () =>
          import('./pages/appointments/appointment.component').then(
            (m) => m.AppointmentComponent
          ),
      },
      {
        path: 'meta-tests',
        loadComponent: () =>
          import('./pages/meta-tests/meta-tests.component').then(
            (m) => m.MetaTestsComponent
          ),
      },
      {
        path: ':clientName/payments-and-appointments/:patientId',
        loadComponent: () =>
          import(
            './pages/patient-payments-and-appointments/patient-payments-and-appointments.component'
          ).then((m) => m.PatientPaymentsAndAppointmentsComponent),
      },
      {
        path: 'payments/:patientId',
        loadComponent: () =>
          import('./pages/payment/payment.component').then(
            (m) => m.PaymentComponent
          ),
      },
      {
        path: 'payments',
        loadComponent: () =>
          import('./pages/payment/payment.component').then(
            (m) => m.PaymentComponent
          ),
      },
      {
        path: 'employees',
        loadComponent: () =>
          import('./pages/employees/employees.component').then(
            (m) => m.EmployeesComponent
          ),
      },
      {
        path: 'suppliers',
        loadComponent: () =>
          import('./pages/suppliers/supplier.component').then(
            (m) => m.SupplierComponent
          ),
      },
      {
        path: 'supplier-orders/:supplierId',
        loadComponent: () =>
          import('./pages/suppliers-orders/suppliers-orders.component').then(
            (m) => m.SuppliersOrdersComponent
          ),
      },
      {
        path: 'plans',
        loadComponent: () =>
          import('./pages/plans/plans.component').then((m) => m.PlansComponent),
      },
      {
        path: 'subscriptions',
        loadComponent: () =>
          import('./pages/subscriptions/subscriptions.component').then(
            (m) => m.SubscriptionsComponent
          ),
      },
    ],
  },
  {
    path: '',
    component: GuestComponent,
    canActivate: [NoAuthGuard],
    children: [
      {
        path: 'auth/login',
        loadComponent: () =>
          import('./pages/auth/login/login.component').then(
            (m) => m.LoginComponent
          ),
      },
    ],
  },
];
